<template>
  <div :class="[modifier, disabled ? 'cursor-not-allowed' : '']" @click="goToWizard">
    <div v-bind="$attrs" class="my-4 button" v-if="title">{{ title }}</div>
    <svg class="icon add_icon scale" v-else>
      <use xlink:href="#add-icon"></use>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'WizardButton',

  props: {
    title: {
      type: String,
      default: '',
    },

    modifier: {
      type: String,
      default: '',
    },

    disabled: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    goToWizard() {
      if (this.disabled) return;

      this.$inertia.visit(this.$route('wizard.index'));
    },
  },
};
</script>
<style lang="scss" scoped>
.add_icon {
  color: var(--theme);
}

.scale {
  transform: scale(1.67);
}

.card {
  &_add {
    min-height: 8rem;
  }
}
</style>
